/* eslint-disable max-len */
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchFloatingInventoryReport = ({
  dealerId,
  allLines = true,
  dateFrom = '',
  dateTo = '',
  dealer = '',
  model = '',
  katashiki = '',
  order = '',
}) =>
  apiActionCreator({
    'endpoint':
      `/vehicles/get-floating-inventory-report?dealerId=${dealerId}&all_lines=${allLines || ''}&is_report=S&date_from=${dateFrom || ''}&date_to=${dateTo || ''}&dealer=${dealer || ''}&model=${model || ''}&katashiki=${katashiki || ''}&order=${order || ''}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_FLOATING_INVENTORY_REPORT,
      ActionTypes.FETCHED_FLOATING_INVENTORY_REPORT,
      [
        ActionTypes.FETCHED_FLOATING_INVENTORY_REPORT_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchVehiclesOrders = () => apiActionCreator({
  'endpoint': '/vehicles/vehicles-orders',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_VEHICLES_ORDERS_LIST,
    ActionTypes.FETCHED_VEHICLES_ORDERS_LIST,
    [
      ActionTypes.FETCHED_VEHICLES_ORDERS_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const clearFloatingInventoryReport = (value) => ({
  'type': ActionTypes.CLEAN_FLOATING_INVENTORY_REPORT,
  'payload': value,
});
